const firebaseConfig = {
  apiKey: "AIzaSyAzNTstAp_RiIAm65rkl6oUZfNCJQqR2jI",
  authDomain: "poko-delivery.firebaseapp.com",
  projectId: "poko-delivery",
  storageBucket: "poko-delivery.appspot.com",
  messagingSenderId: "197010651115",
  appId: "1:197010651115:web:279967d0ffc323de90cbae"
};
export default firebaseConfig;